import ApiClient from '@/lib/ApiClient';
import { CartPopupService } from './services';
import { CartPopupRequest, CartPopupResponse } from './types';
import Result from '@/lib/Result';

export default class CartPopupApiService implements CartPopupService {
  constructor(private readonly apiClient: ApiClient) {}

  public async getList(request?: CartPopupRequest): Promise<Result<CartPopupResponse | undefined>> {
    try {
      const res = await this.apiClient.get('/shoppingCart/menu', {
        credentials: request?.cookie ? 'include' : undefined,
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const json: CartPopupResponse = await res.json();

      return new Result(json);
    } catch (error) {
      return new Result(undefined);
    }
  }
}
